// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/constantes.js
//  WIKI_CATS · wCat
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export const WIKI_CATS = {
  moderation: { label: "Modération", icone: "🛡️", couleur: THEME.red,     fond: THEME.redDim },
  technique:  { label: "Technique",  icone: "⚙️", couleur: THEME.accent,  fond: THEME.accentDim },
  lore:       { label: "Lore",       icone: "📖", couleur: THEME.purple,  fond: THEME.purpleDim },
  rh:         { label: "RH",         icone: "🤝", couleur: THEME.emerald, fond: THEME.emeraldDim },
  procedures: { label: "Procédures", icone: "🚨", couleur: THEME.amber,   fond: THEME.amberDim },
  general:    { label: "Général",    icone: "🗂️", couleur: THEME.textMuted, fond: THEME.surface },
};

export const wCat = (c) => WIKI_CATS[c] || WIKI_CATS.general;
